import React from 'react';
import CurrencyInput from 'react-currency-input';
import mobx, { autorun, transaction } from 'mobx';
import MobxReactForm from 'mobx-react-form';
import validatorjs from 'validatorjs';
import { inject, observer } from 'mobx-react/index';
import WorkflowStepBaseComponent from '../workflow/steps/workflow-step-base';
import TemplateStore from '../template/emailtemplate-store';
import WorkflowStore from '../workflow/workflow-store';
import TimelineStore from '../workflow/steps/timeline/timeline-workflow-step-store';
import Notifications from '../utils/notification-helper';
import Editor from '../shared/skyckeditor';
import { Checkbox, MenuItem,DropdownButton } from 'react-bootstrap';
import Cons from '../../isomorphic/cons';

const plugins = { dvr: validatorjs };
const fields = [
    'id',
    'name',
    'body',
    'subject'
   
];
const labels = {
    name: 'Name of template',
    body: 'Body',
    subject: 'Subject'
    
};
const types = {};
const rules = {
    name: 'required',
    subject: 'required',
    body: 'required',
};
const extra = {};
const disabled = { };
const bindings = {};

const makeTemplateForm = function() {
    return new MobxReactForm({ fields, rules, bindings, labels, types, disabled, extra }, { plugins });
};
@inject('appStore')
@observer
export default class EmailTemplateCreateComponent extends WorkflowStepBaseComponent {
    constructor(props) {
        super(props);
        this.form = makeTemplateForm();
        this.state = { hasClickedSteps:false, countCheck:0, readyForChanges: false, isLoading:false, tags: [],tagsFiltered: [], typeFile:'none', 
                     toSelected:[], ccSelected:[] };
        this.templateStore = new TemplateStore(appStore);
        this.workflowStore = new WorkflowStore(appStore);
        this.timelineStore = new TimelineStore(appStore);
        this.loadTagsOptions();
    }

    updateFieldsFromStore(template) {
        _.each(mobx.toJS(template), (value, key) => {
            this.form.$(key).set(_.isUndefined(value) ? '' : value);
        });
    }

    validateFields()
    {
        let formattedFields = {};
        _.each(this.form.values(), (value, key) => {
                formattedFields[key] = value;           
        });

        this.templateStore.template.name=formattedFields.name;
        this.templateStore.template.subject=formattedFields.subject;

        if(this.templateStore.template.name=='' || this.templateStore.template.body==undefined ||
         this.templateStore.template.body=='' || this.templateStore.template.subject=='')
         {
             return false;
         }

        return true;
    }

     loadTagsOptions()
    {
        var otherSteps=this.workflowStore.loadAllAuditSteps();
        var arraySteps = new Array();
        otherSteps.map(steps =>{
                    
            var found = arraySteps.find(element => (element.title ==steps.title && element.type == steps.type));
            if(!found)
            {
            if(steps.type!=null)
            {
                var nameId = steps.title.replace(" ","");
            var step ={type:steps.type,
                    id: nameId+steps.type,
                    title: steps.title,
                    section: steps.section};
                    arraySteps.push(step);
                    
              }
            }
        });

         this.state.tags = arraySteps;
        return ;
    }
    
    chargeStyle(isAuditStep)
    {
        var labels = [];
        for(let i=0; i< Object.values(Cons.prime.FileContacTypeKeyLabel).length; i++){
            labels.push(Object.values(Cons.prime.FileContacTypeKeyLabel)[i]);
          }

        if(isAuditStep == true)
        {
            this.setState({hasClickedSteps: true});
        }
        var checkbox = document.getElementsByClassName("checkbox");
        Array.from(checkbox).forEach((el) =>  {
            el.style.height="0px";
            el.style.marginBottom="0px";
          });
          Array.from(this.state.tagsFiltered).forEach((el) =>  {
              var id= 'lbl-'+el.type;
              if(document.getElementById(id)!=null)
              {
            document.getElementById(id).style.paddingLeft="20px";
        }
          });
          Array.from(labels).forEach((el,key) =>  {
            var id= 'lbl-to-'+el;
            var id2= 'lbl-cc-'+el;
            if(document.getElementById(id)!=null)
            {
                document.getElementById(id).style.paddingLeft="20px";
            }
            if(document.getElementById(id2)!=null)
            {
                document.getElementById(id2).style.paddingLeft="20px";
            }
        });
          
       for (let index = 1; index >0 && index < 4; index++) {
        if(document.getElementsByClassName("dropdown-menu")[index].style!=null)
        {
          document.getElementsByClassName("dropdown-menu")[index].style.height="300px";
          document.getElementsByClassName("dropdown-menu")[index].style.overflowY="scroll";
        }
           
       }
    }
    handleChange = (e, tag)=> {

        e.stopPropagation();
        if(document.getElementById(tag).checked)
        {
            this.setState({countCheck : this.state.countCheck+1});
        }

        else
        {
            this.setState({countCheck :  this.state.countCheck-1});
        }
    }

    changeValue = (e, tag)=> {
        document.getElementById(tag).checked = !document.getElementById(tag).checked;

        if(document.getElementById(tag).checked)
        {
            this.setState({countCheck : this.state.countCheck+1});
        }

        else
        {
            this.setState({countCheck :  this.state.countCheck-1});
        }
        e.stopPropagation();
    }

    resetCheckboxes()
    {
        this.state.tags.map(tag => {
            if(document.getElementById(tag.id) != undefined)
            {
            document.getElementById(tag.id).checked = false;
        }
        });
    }

    selectedTypeFile(event){

        this.state.tagsFiltered=[];
        this.state.typeFile = event.target.value;
        var arraySteps = new Array();
        if(this.state.typeFile =="default")
        {

            this.state.tags.map(steps => {
                if(steps.section == "default")
                   {
                      arraySteps.push(steps);
                   }
            });

        }

        else
        {
            if(this.state.typeFile !="none")
            {
            this.state.tags.map(steps => {
                if(steps.section == null)
                   {
                      arraySteps.push(steps);
                   }
                });
                
            }
        }

        this.setState({tagsFiltered: arraySteps, countCheck:this.state.tagsFiltered.length, hasClickedSteps:false });
        this.chargeStyle();
        this.resetCheckboxes();
    }

   
    handleTemplateCreate() {
        
        var tags = this.state.tagsFiltered;
        var contactTypes = Cons.prime.FileContacTypeKeyLabel;
        var result = [];
        for(var i in contactTypes){ result.push(contactTypes[i]);}

        tags.map(tag =>{
            if(!document.getElementById(tag.id).checked)
            {
                var id = tag.type;
                this.state.tagsFiltered = this.state.tagsFiltered.filter(function(tag) {
                    return tag.type !== id; 
                });
            } 
            else{
                if(tag.type != undefined && this.state.typeFile!=='default' )
                {
                tag.type = tag.type + '-'+ this.state.typeFile;
            }
            }
        });
        
        result.map(key =>{
            if(document.getElementById('chk-to-'+key).checked)
            {
                this.state.toSelected.push(key);
            } 
            if(document.getElementById('chk-cc-'+key).checked)
            {
                this.state.ccSelected.push(key);
            }  
            });
      
        if(this.validateFields())
            {
                
                this.state.isLoading = true;
                this.templateStore
                    .createTemplate(this.templateStore.template,this.state.tagsFiltered,this.state.toSelected,this.state.ccSelected)
                    .then((templateResult) => {
                        this.props.handleTemplateCreated(this.templateStore.template, templateResult);
                        Notifications.ToastSuccess("Template created succefully..");
                    })
                    .catch((error) => {
                        Notifications.ToastError(error.message);
                    });

                    this.templateStore.resetTemplate();
             }
    }

    render() {
    
        return (
            <div className="row">
                <form key={`template-step`}>
                    <div className="col-xs-12 col-sm-12">
                        <div className="form-group">
                            <label htmlFor={this.form.$(`name`).id} className="required">
                                {this.form.$(`name`).label}
                            </label>
                            <input className="form-control" {...this.form.$(`name`).bind()} />
                            <p className="form-error">{this.form.$(`name`).error}</p>
                        </div>
                    </div>


                    <div className="col-xs-12 col-sm-12">
                        <div className="form-group">
                            <label htmlFor={this.form.$(`subject`).id} className="required">
                                {this.form.$(`subject`).label}
                            </label>
                            <input className="form-control" {...this.form.$(`subject`).bind()} />
                            <p className="form-error">{this.form.$(`subject`).error}</p>
                        </div>
                    </div>

                    <div className="col-xs-12 col-sm-12">
                    <div className="form-group">
                          <label className="required">
                             Type of file
                        </label> <br />
                        <select className="form-control"   onChange={this.selectedTypeFile.bind(this)} >
                            <option key="none" value="none">
                                                Select a value
                            </option>
                           <option key="default" value="default">
                                                Generic
                            </option>
                            <option key="double-ended" value="double-ended">
                                                Double Ended
                            </option>
                            
                            <option key="listing" value="listing">
                                               Listing
                            </option>
                            <option key="listing-gone-pending" value="listing-gone-pending">
                                               Listing Gone Pending
                            </option>
                            <option key="sale" value="sale">
                                                Sale
                            </option>
                            
                        </select> <br />
                         <label className="required">
                             Audit step
                        </label> <br />
                        <DropdownButton 
                        title="Audit step" 
                        className="btn"
                        bsStyle="default"
                        disabled={this.state.typeFile=='none'}
                        onClick = {this.chargeStyle.bind(this, true)}
                        >
                        {_.map(this.state.tagsFiltered, tag => {
                                return (   
                                <MenuItem onClick={(e) => this.changeValue(e,tag.id)} >
                                <Checkbox  id={tag.id}  onClick={(e) => this.handleChange(e,tag.id)} />
                                    <label id={'lbl-'+tag.type } onClick={(e) => this.changeValue(e,tag.id)}> {tag.title} </label>
                                 </MenuItem>
                                );
                            })}
                        </DropdownButton>
                        
                        { (this.state.hasClickedSteps && this.state.countCheck==0 ) && (
                         <p className="form-error" >Select an Audit Step</p>
                          )}
                         <div className="form-group">
                         <br />
                         <label>
                            Emails TO
                        </label> <br />
                        <DropdownButton 
                        title="TO emails" 
                        className="btn"
                        bsStyle="default"
                        onClick = {this.chargeStyle.bind(this)}
                        >
                        {_.map(Cons.prime.FileContacTypeKeyLabel, (key,label) => {
                                return (   
                                <MenuItem >
                                <Checkbox  id={'chk-to-'+key}  onClick={(e) => this.handleChange(e,key)} />
                                    <label id={'lbl-to-'+key } onClick={(e) => this.changeValue(e,'chk-to-'+key)}> {label} </label>
                                 </MenuItem>
                                );
                            })}
                        </DropdownButton>
                        <br />
                        <br />
                         <label >
                             Emails CC
                        </label> <br />
                        <DropdownButton 
                        title="CC Emails" 
                        className="btn"
                        bsStyle="default"
                        onClick = {this.chargeStyle.bind(this)}
                        >
                         {_.map(Cons.prime.FileContacTypeKeyLabel, (key,label) => {
                                return (   
                                <MenuItem >
                                <Checkbox  id={'chk-cc-'+key}  onClick={(e) => this.handleChange(e,key)} />
                                    <label id={'lbl-cc-'+key } onClick={(e) => this.changeValue(e,'chk-cc-'+key)}> {label} </label>
                                 </MenuItem>
                                );
                            })}
                        </DropdownButton>
                        </div>
                        </div>
                        </div>
                    <div className="col-xs-12 col-sm-12">
                        <div className="form-group">
                            <label htmlFor={this.form.$(`body`).id} className="required">
                                {this.form.$(`body`).label}
                            </label>
                            <Editor
                            container="editable"
                            editorId="template-new"
                            onReady={() => {
                                this.setState({ readyForChanges: true });
                            }}
                            handleFormChange={_.debounce(
                                () => {
                                    if (this.state.readyForChanges) {
                                        const data = CKEDITOR.instances['template-new'].getData();
                                        this.templateStore.template.body=data;
                                        this.validateFields();
                                    }
                                },
                                1000,
                                { maxWait: 1000 }
                            )}
                        />
                         { (this.templateStore.template.body=='' || this.templateStore.template.body=="") && (
                         <p className="form-error" >The Body field is required</p>
                          )}
                       
                        </div>
                    </div>
     
                </form>
                <div className="col-xs-12 col-sm-12">
                    <div className="form-group">
                        <button
                            className="btn btn-success"
                            onClick={this.handleTemplateCreate.bind(this)}
                            disabled ={this.templateStore.template.name=='' || this.templateStore.template.name==undefined||
                            this.templateStore.template.body=='' || this.templateStore.template.body==undefined ||
                            this.templateStore.template.subject=='' || this.templateStore.template.subject==undefined 
                             || this.state.countCheck == 0}
                        >
                            {this.state.isLoading ? 'Creating...' : 'Create Template'}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/template/emailtemplate-create-component.js